import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import EventCard from 'components/Event/Card'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import QrCode2Icon from '@mui/icons-material/QrCode2'
import DialogQR from 'components/Dialogs/DialogQR'

export default function EventIndex() {
  const loginUser = useAppSelector((s) => s.UI.auth)
  const events = useAppSelector((s) => s.Event.list)
  const [showAllEvent, setShowAllEvent] = useState(
    Boolean(Number(localStorage.getItem('showAllEvent')))
  )
  const dispatch = useAppDispatch()
  const [showQR, setShowQR] = useState(false)
  useEffect(() => {
    dispatch(
      UIAction.setBreadcrumbs([
        {
          text: 'ホーム',
          url: '/',
        },
        {
          text: 'イベント一覧',
          url: '/event',
        },
      ])
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <DialogQR
        open={showQR}
        url={`http://192.168.1.113:5007/login/?organizer=${loginUser?.id}`}
        header={<h4 className="text-center">{loginUser?.id}</h4>}
        footer={<h4 className="text-center">イベントリスト</h4>}
        handleClose={() => setShowQR(false)}
      />
      <Grid container spacing={1} mt={2}>
        <Grid item xs={12}>
          <Typography
            variant="h5"
            component="h2"
            sx={{ borderBottom: 2 }}
            fontWeight="bold"
          >
            イベント管理
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Stack
            direction={{
              xs: 'column-reverse',
              md: 'row',
            }}
            spacing={1}
            alignItems={{
              xs: 'flex-start',
              md: 'center',
            }}
            justifyContent="space-between"
          >
            <Typography variant="h6" component="h3" fontWeight="bold">
              イベント一覧
            </Typography>
            <Link to="/event/register">
              <Button
                color="secondary"
                variant="contained"
                sx={{
                  px: 6,
                  borderColor: '#aaa',
                  borderRadius: 2,
                }}
              >
                新規登録
              </Button>
            </Link>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={showAllEvent}
                onChange={(event) => {
                  const checked = event.target.checked
                  localStorage.setItem(
                    'showAllEvent',
                    Number(checked).toString()
                  )
                  setShowAllEvent(checked)
                }}
              />
            }
            label="終了したイベントを表示する"
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {events
              .filter((f) => showAllEvent || f.endDate > new Date().getTime())
              .reverse()
              .map((v, i) => {
                return (
                  <Grid item xs={12} md={6} key={i}>
                    <EventCard
                      to={'/event/' + v.id}
                      title={v.name}
                      place={v.prefecture.name + v.address}
                      time={`${format(v.startDate, 'yyyy/MM/dd')} ～ ${format(
                        v.endDate,
                        'yyyy/MM/dd'
                      )}`}
                      summary={v.summary}
                      released={v.released}
                      src={v.image}
                    />
                  </Grid>
                )
              })}
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          ml={1}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Stack alignItems="center" justifyContent="center">
            <Button
              sx={{
                width: 200,
                mt: 4,
              }}
              size="small"
              color="primary"
              variant="outlined"
              onClick={() => {
                setShowQR(true)
              }}
            >
              <Typography>二次元コード表示</Typography>
              <QrCode2Icon
                sx={{
                  ml: 0.5,
                }}
              />
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  )
}
